import Http from "./axiosInstance";
import Alert from "../utils/Alert";
import { aesDecrypt, aesEncrypt } from "../utils/Aes";

let headers = {};

let loadingFunctions = null;

export const setLoadingFunctions = (functions) => {
  loadingFunctions = functions;
};

const startLoading = () => {
  if (loadingFunctions && loadingFunctions.startLoading) {
    loadingFunctions.startLoading();
  }
};

const completeLoading = () => {
  if (loadingFunctions && loadingFunctions.completeLoading) {
    loadingFunctions.completeLoading();
  }
};

const httpClient = {
  get: async (endpoint) => {
    try {
      const response = await Http.get(endpoint);
      return response.data;
    } catch (error) {
      Alert.failure(error.message);
      throw new Error(error.message);
    }
  },

  post: async (endpoint, payLoad) => {
    startLoading();
    headers = { token: localStorage.getItem("token") };
    try {
      let post = payLoad;
      if (Object.keys(payLoad).length > 0) {
        const encryptedData = aesEncrypt(JSON.stringify(payLoad));
        post = { request: encryptedData };
      }
      const response = await Http.post(endpoint, post, { headers: headers });
      completeLoading();
      const res = aesDecrypt(response.data.data);
      return { requestStatus: "OK", result: JSON.parse(res) };
    } catch (error) {
      completeLoading();
      Alert.failure(error.message);
      return { requestStatus: "ERROR", message: error.message };
    }
  },

  sendRequest: async (endpoint, payLoad) => {
    headers = { token: localStorage.getItem("token") };
    try {
      let post = payLoad;
      if (Object.keys(payLoad).length > 0) {
        const encryptedData = aesEncrypt(JSON.stringify(payLoad));
        post = { request: encryptedData };
      }
      const response = await Http.post(endpoint, post, { headers: headers });
      return { requestStatus: "OK", result: response.data };
    } catch (error) {
      Alert.failure(error.message);
      return { requestStatus: "ERROR", message: error.message };
    }
  },

  upload: async (endpoint, formData) => {
    startLoading();
    headers = { token: localStorage.getItem("token") };
    try {
      const response = await Http.post(endpoint, formData, {
        headers: { ...headers, "Content-Type": "multipart/form-data" },
      });
      completeLoading();
      return { requestStatus: "OK", result: response.data };
    } catch (error) {
      completeLoading();
      Alert.failure(error.message);
      return { requestStatus: "ERROR", message: error.message };
    }
  },

  plainRequest: async (endpoint, payLoad) => {
    try {
      let post = payLoad;
      if (Object.keys(payLoad).length > 0) {
        const encryptedData = aesEncrypt(JSON.stringify(payLoad));
        post = { request: encryptedData };
      }
      const response = await Http.post(endpoint, post, { headers: headers });
      completeLoading();
      const res = aesDecrypt(response.data.data);
      return { requestStatus: "OK", result: JSON.parse(res) };
    } catch (error) {
      completeLoading();
      Alert.failure(error.message);
      return { requestStatus: "ERROR", message: error.message };
    }
  },
};

export default httpClient;
